import { useRef, useState } from "react";
import { useTranslation } from "react-i18next";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowsRotate, faEllipsisVertical } from "@fortawesome/free-solid-svg-icons";

import Dropdown from "components/OptionsCard/Dropdown";
import { Option } from "components/OptionsCard/typings";
import ChangeKindIcon from "assets/icons/mode_edit.svg?react";
import UngroupIcon from "assets/icons/link.svg?react";
import PrintIcon from "assets/icons/print.svg?react";
import { IDispatchListItem } from "dto/Mailroom/IDispatchChart";

import styles from "./outgoing.module.scss";

interface Props {
  item: IDispatchListItem;
  onChangeKind: (item: IDispatchListItem) => void;
  /** Rozgrupowanie koperty wspólnej — tylko dla wiersza IsGroupingParcel. */
  onUngroup?: (item: IDispatchListItem) => void;
  /** Drukowanie przesyłki (pismo, naklejka, koperta, zwrotka ZPO). */
  onPrint?: (item: IDispatchListItem) => void;
  /** „Aktualizuj dane adresata” — dostępne, gdy książka adresowa ma nowsze dane. */
  onRefreshReceiverData?: (item: IDispatchListItem) => void;
}

// Dropdown podaje ikonie className z rozmiarem.
const RefreshIcon = ({ className }: { className?: string }) => (
  <FontAwesomeIcon icon={faArrowsRotate} className={`${className ?? ""} ${styles.rowMenuIcon}`} />
);

// Menu „więcej" (ikona kebab) dla wiersza listy „Do wysyłki" — wzorzec jak w
// AddressBookVerificationsManager/MenuCell (ellipsis + współdzielony Dropdown).
// Trzyma własny stan/otwarcie i ref kotwicy (Dropdown → Popper kotwiczy do refWrapper).
const OutgoingRowMenu = ({ item, onChangeKind, onUngroup, onPrint, onRefreshReceiverData }: Props) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const refWrapper = useRef<HTMLDivElement>(null);

  const options: Option[] = [
    {
      name: "Drukuj…",
      Icon: PrintIcon,
      callback: () => onPrint?.(item),
      additional: false,
      isEnabled: !!onPrint,
      canMultiple: false,
    },
    {
      name: "Zmień sposób nadania",
      Icon: ChangeKindIcon,
      callback: () => onChangeKind(item),
      additional: false,
      isEnabled: true,
      canMultiple: false,
    },
    {
      name: "Rozgrupuj kopertę",
      Icon: UngroupIcon,
      callback: () => onUngroup?.(item),
      additional: false,
      isEnabled: !!item.IsGroupingParcel && !!onUngroup,
      canMultiple: false,
    },
    {
      name: t("receiverData.refresh"),
      Icon: RefreshIcon,
      callback: () => onRefreshReceiverData?.(item),
      additional: false,
      isEnabled: !!item.ReceiverDataOutdated && !!onRefreshReceiverData,
      canMultiple: false,
    },
  ];

  return (
    <div className={styles.rowMenu}>
      <div
        ref={refWrapper}
        className={styles.rowMenuTrigger}
        title="Więcej"
        onClick={(e) => {
          // wiersz jest <label> — nie przełączaj checkboxa / podglądu.
          e.preventDefault();
          e.stopPropagation();
          setOpen((v) => !v);
        }}
        onDoubleClick={(e) => e.stopPropagation()}
      >
        <FontAwesomeIcon icon={faEllipsisVertical} />
      </div>
      {open && (
        <Dropdown
          toggle={() => setOpen(false)}
          options={options}
          refWrapper={refWrapper}
          rightSide={true}
          scrollWrapper={refWrapper}
          showOptions={open}
          selectedElements={[]}
          setSelectedElements={() => {}}
        />
      )}
    </div>
  );
};

export default OutgoingRowMenu;
